import { useQuery } from "./useQuery";
import Navigation from "./Navigation";
import Homepage from "./Homepage";
import FPBioimagePage from "./FPBioimagePage";
import PasswordProtection from "./PasswordProtection";

const RouteManager = () => {
  const queryParams = useQuery();
  const datasetName = queryParams.get("demo");
  const secureDatasetName = queryParams.get("secure");

  return (
    <>
      <Navigation />
      {!!datasetName ? (
        <FPBioimagePage datasetName={datasetName} />
      ) : !!secureDatasetName ? (
        <PasswordProtection secureDatasetName={secureDatasetName}>
          <FPBioimagePage datasetName={secureDatasetName} isSecure={true} />
        </PasswordProtection>
      ) : (
        <Homepage />
      )}
    </>
  );
};

export default RouteManager;
